import {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Icon} from 'front-onceforall-core';
import Tooltip from '@material-ui/core/Tooltip';
import TextCheckbox from 'front-onceforall-core/dist/components/TextCheckbox';
import * as snackbarsActions from '../../../../actions/snackbars';
import {selectOrganisation} from '../../../../actions/organisation';
import {captureError} from '../../../../utils/log';
import authenticationService from '../../../../services/authentication/AuthenticationService';
import organisationService from '../../../../services/organisation/OrganisationService';

export class InvitationSettingsForm extends Component {
  constructor(props) {
    super(props);

    this.isManager = authenticationService.roles().isManager();

    this.state = {
      hasChanged: false,
      priorAcceptation: props.organisation.priorAcceptation,
      depositor: props.organisation.depositor,
      priorAcceptationDisabled: !props.organisation.depositor || !this.isManager
    };

    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getPriorAcceptationControl = this.getPriorAcceptationControl.bind(this);
  }

  getPriorAcceptationControl() {
    const tooltipKey = this.isManager ? 'settings.invitation.priorAcceptation.notDepositor' : 'settings.invitation.priorAcceptation.notManager';
    const formControl =
      (<TextCheckbox
        data-id="priorAcceptation"
        checked={!this.state.priorAcceptation}
        onChange={this.handleSwitch}
        label={<Translate value={'settings.invitation.priorAcceptation.label'}/>}
        disabled={this.state.priorAcceptationDisabled}
      >
      </TextCheckbox>);
    if (this.state.priorAcceptationDisabled) {
      return (
        <Tooltip
          title={<Translate value={tooltipKey}/>}
          placement="top"
        >
          <span>{formControl}</span>
        </Tooltip>
      );
    }

    return formControl;
  }

  handleSwitch() {
    this.setState(state => ({
      hasChanged: true,
      priorAcceptation: !state.priorAcceptation
    }));
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.isManager || !this.state.hasChanged) {
      return;
    }

    this.setState({hasChanged: false});

    organisationService.updatePriorAcceptation(this.props.organisation.organisationId, this.state.priorAcceptation)
      .then(() => {
        this.props.actions.selectOrganisation(
          {...this.props.organisation, priorAcceptation: this.state.priorAcceptation}
        );
        this.props.actions.addSuccess(<Translate value="message.changesSaved"/>);
      })
      .catch(error => {
        captureError('Error while update organisation invitation settings', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
      });
  }

  render() {
    return (
      <>
        <h2>
          <Translate value={'settings.invitation.title'}/>
        </h2>
        <form
          className="card"
          onSubmit={this.handleSubmit}
        >
          {this.getPriorAcceptationControl()}
          {!this.state.priorAcceptationDisabled &&
          <div className="actions row justify-content-end">
            <button
              className="large cta inline-container"
              type="submit"
              disabled={!this.state.hasChanged}
            >
              <Icon icon="check"/>
              <Translate value="action.confirm"/>
            </button>
          </div>}
        </form>
      </>
    );
  }
}

InvitationSettingsForm.propTypes = {
  actions: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions, selectOrganisation}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InvitationSettingsForm);
